import Breadcrumb from "../../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import {
  Button,
  Box,
  Paper,
  Stepper,
  Step,
  StepLabel,
  Grid,
} from "@mui/material";
import { PageContainer } from "../../../App/Components/PageContainer/PageContainer";
import SortableTable from "../../../App/Components/Table/SortableTable";
import { useFlags } from "launchdarkly-react-client-sdk";
import { FeatureFlags } from "../../../App/Typings/FeatureFlags";
import Modal from "../../../App/Components/Modals/Modal";
import ModalForm from "../../../App/Components/Modals/Components/ModalForm";
import { useModalHooks } from "../../../App/State/Hooks/useModalHooks";
import AbacUserTableCell from "./Components/AbacUserTableCell";
import useAbacUserState from "./State/AbacUsersState";
import CreateUserForm from "./Components/CreateUserForm";
import { ModalType } from "../../../App/Enums/ModalType";
import AttributeAssignmentComponent from "../../../App/Components/ABAC/AttributeAssignmentComponent";
import { useParams } from "react-router-dom";

export default function AbacUsersPage() {
  const {
    getters: {
      users,
      columns,
      usersLoading,
      createUserModalTitle,
      attributeAssignementModalTitle,
      formik,
      activeStep,
      steps,
    },
    handlers: { handleCreateModalClose },
  } = useAbacUserState();

  const { isModalTypeOpen, openModal } = useModalHooks();

  // Initialize EnableABACApplicationManagement LD flag
  // TODO: Remove with ABAC-32
  const { enableAbacApplicationManagement } = useFlags<FeatureFlags>();

  return (
    enableAbacApplicationManagement && (
      <>
        <PageContainer>
          <Breadcrumb pageTitle={"Users"} customBreadcrumbs={[]} />
          <h1 className="page-title">Users</h1>
          <Paper sx={{ mt: 4, p: { xs: 2, lg: 4 } }}>
            <Box>
              <Box
                sx={{
                  width: "100%",
                  position: "relative",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  sx={{
                    position: "absolute",
                    right: "0px",
                    top: "0px",
                    left: { xs: "0px", sm: "unset" },
                  }}
                  onClick={() => openModal()}
                >
                  Create New User
                </Button>
              </Box>
              <Box
                sx={{
                  pt: { xs: "3rem", sm: "unset" },
                }}
              >
                <SortableTable
                  columns={columns}
                  tableData={users}
                  rowComponent={AbacUserTableCell}
                  loading={usersLoading}
                  hideSearch={false}
                  defaultSortIndex={0}
                  setTableData={undefined}
                  reverse={false}
                  customProps={undefined}
                />
              </Box>
            </Box>
          </Paper>
          <Modal
            fullWidth
            maxWidth="lg"
            open={isModalTypeOpen(ModalType.General)}
            title={createUserModalTitle}
            hasLoadingBar={true}
            hasCloseButton={false}
            isProcessing={false}
            handleClose={handleCreateModalClose}
          >
            <Stepper activeStep={activeStep} sx={{ mb: "5%" }}>
              {steps.map((label, index) => {
                return (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
            {activeStep === 0 ? (
              <ModalForm formik={formik} isProcessing={false}>
                <CreateUserForm />
              </ModalForm>
            ) : (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <AttributeAssignmentComponent
                    handleClose={handleCreateModalClose}
                  />
                </Grid>
              </Grid>
            )}
          </Modal>

          <Modal
            fullWidth
            maxWidth="lg"
            open={isModalTypeOpen(ModalType.AttributeAssignment)}
            title={attributeAssignementModalTitle}
            hasLoadingBar={true}
            isProcessing={false}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <AttributeAssignmentComponent />
              </Grid>
            </Grid>
          </Modal>
        </PageContainer>
      </>
    )
  );
}
